import React from 'react'
import { Link, useNavigate } from 'react-router-dom';

const MainCardThree = (props) => {
    const {icon,title,count,percentage,duration,img,navigateTo}=props
    const navigate = useNavigate();

    const handleChange = () => {
      navigate(navigateTo);
      };
  return (
         <div className=" col-12  col-lg-4  pb-4">
              <div className="card light-shadow mb-0 n_shadow a_card">
                <a className="card-body" onClick={handleChange} >
                  <div className="stats">
                    <span className="icon">
                      {/* <i>
                      {icon}
                      </i> */}
                      <img src={img} style={{height: "54px"}}/>
                    </span>
                    <p>{title}</p>
                    <h2>{count}</h2>
                    <span className="groth text-success">
                      <i
                        className="arrow-up"
                        style={{ borderColor: "transparent" }}
                      >{percentage}</i>
                      
                    </span>
                  </div>
                  <div className="compare">
                    <span>{duration}</span>
                  </div>
                </a>
              </div>
            </div>
  )
}

export default MainCardThree
